import { render, staticRenderFns } from "./Shopee.vue?vue&type=template&id=f2ff79f8&"
import script from "./Shopee.vue?vue&type=script&lang=js&"
export * from "./Shopee.vue?vue&type=script&lang=js&"
import style0 from "./Shopee.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports